module.exports = __webpack_public_path__ + "static/mentor-adarsh-17940ef8a0f7c8798064de4dffbcb8c3.png";